<!-- 文件上传模板下载组件 -->
<template>
  <div class="uploadDownLoad">
    <file-upload
      class="upLoad"
      :showName="showName"
      :action-addr="actionAddr"
      :tips="tips"
      :data="data"
      :showIcon="showIcon"
      :btn-type="btnType"
      :size="size"
      :plain="plain"
      @onErrorList="onShowUploadErrorList"
      @success="onUploadSuccess"
    />
    <div class="divider"></div>
    <TemplateDownload
      class="downLoad"
      :showIcon="showIcon"
      :showName="templateDownloadName"
      :index="downloadIndex"
      :is-tag="downloadIsTag"
      :tips="downloadTips"
      :btn-type="btnType"
      :download-addr="downloadAddr"
      :size="size"
      :plain="plain"
      @onDelete="onDelete"
    />
  </div>
</template>

<script setup>
import FileUpload from "@/components/uploadDownload/fileUpload.vue";
import TemplateDownload from "@/components/uploadDownload/templateDownload.vue";

const props = defineProps({
  showName: {
    required: false,
    type: String,
    default: "导入",
  },
  templateDownloadName: {
    required: false,
    type: String,
    default: "模板",
  },
  actionAddr: {
    required: true,
    type: String,
  },
  tips: {
    required: false,
    type: String,
    default: "",
  },
  data: {
    // 上传时附带的额外参数
    required: false,
    type: Object,
    default: {},
  },
  disabled: {
    // 是否禁用上传
    required: false,
    type: Boolean,
    default: false,
  },
  showIcon: {
    required: false,
    type: Boolean,
    default: false,
  },
  size: {
    required: false,
    type: String,
    default: "default",
  },

  downloadAddr: {
    required: true,
    type: String,
  },
  downloadTips: {
    // 下载提示
    required: false,
    type: String,
    default: "",
  },
  btnType: {
    required: false,
    type: String,
    default: "",
  },
  downloadIsTag: {
    required: false,
    type: Boolean,
    default: false,
  },
  downloadIndex: {
    required: false,
    type: Number,
    default: 0,
  },
  downloadName: {
    required: false,
    type: String,
    default: null,
  },
  plain: {
    required: false,
    type: Boolean,
    default: false,
  },
});

const emits = defineEmits(["onErrorList", "success", "onDelete"]);
// 上传错误
const onShowUploadErrorList = (data, status) => {
  emits("onErrorList", data, status);
};
// 上传成功
const onUploadSuccess = (response) => {
  emits("success", response);
};

// 下载删除
const onDelete = (index) => {
  emits("onDelete", index);
};
</script>

<style lang="scss" scoped>
.uploadDownLoad {
  display: flex;
  align-items: center;
  min-width: 160px;

  .upLoad :deep(.el-button) {
    border-right: none;
    border-top-right-radius: unset;
    border-bottom-right-radius: unset;
  }

  .updateClass {
    border-right: none;
    border-top-right-radius: unset;
    border-bottom-right-radius: unset;
  }

  .upLoadUpdate:deep(.el-button) {
    margin-left: -1px;
    border-left: none;
    border-top-left-radius: unset;
    border-bottom-left-radius: unset;
  }

  .divider {
    z-index: 2;
    border-right: 1px solid #b3d8ff;
    height: 20px;
  }

  &:hover {
    .divider {
      opacity: 0;
    }
  }

  .downLoad :deep(.el-button) {
    border-left: none;
    border-top-left-radius: unset;
    border-bottom-left-radius: unset;
    margin-left: -1px;
    padding: 9px 5px;
  }
}
</style>
